import { SupportFolderSchema } from "@redotech/redo-model/support-folder";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getSupportFolderById = {
  name: "getSupportFolderById" as const,
  input: z.object({ folderId: zExt.objectId() }),
  output: SupportFolderSchema.nullable(),
};
